var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoctionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.47516 7.65591C3.36838 3.73032 6.71024 1.74769 10.127 1.75C13.5439 1.75231 16.8837 3.73971 17.7722 7.66556L17.7722 7.6656C18.8294 12.3354 15.9362 16.3756 13.2043 18.999L13.2029 19.0004C11.4844 20.659 8.76443 20.661 7.03393 18.9997C4.31182 16.3762 1.4181 12.3261 2.47516 7.65591ZM10.128 0.250002C14.1085 0.252693 18.1637 2.60029 19.2352 7.33441C20.4779 12.8239 17.0521 17.3834 14.2442 20.08C11.9429 22.3008 8.30362 22.2989 5.99423 20.0809L5.99328 20.08C3.19553 17.3836 -0.230456 12.8139 1.01225 7.32441L1.01242 7.32364C2.08935 2.58953 6.14736 0.247312 10.128 0.250002ZM7.75489 9.30994C7.75489 8.00103 8.81597 6.93994 10.1249 6.93994C11.4338 6.93994 12.4949 8.00103 12.4949 9.30994C12.4949 10.6189 11.4338 11.6799 10.1249 11.6799C8.81597 11.6799 7.75489 10.6189 7.75489 9.30994ZM10.1249 5.43994C7.98755 5.43994 6.25489 7.1726 6.25489 9.30994C6.25489 11.4473 7.98755 13.1799 10.1249 13.1799C12.2622 13.1799 13.9949 11.4473 13.9949 9.30994C13.9949 7.1726 12.2622 5.43994 10.1249 5.43994Z",
    fill: "#C9CACD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoctionIcon);
export default __webpack_public_path__ + "static/media/loction_icon.4b91ae498ae4f87fb9b7d1cd1e765523.svg";
export { ForwardRef as ReactComponent };